import { useNavigate } from "react-router";
import { Block } from "../../Components/Block/Block";
import { Container } from "../../components/Container/Container";
import styles from './Start.module.scss';
import { useFetchData } from "../../services/useFetchData.service";
import { Spinner } from "../../components/Spinner/Spinner";
import { Image } from "../../components/Image/Image";
import { useEffect } from "react";
import { useUserData } from "../../providers/UserDataProvider/useUserData";
import { fbPageView } from "../../utils/FacebookEvents";
import { ampOnboardingStarted } from "../../utils/AmplitudeEvents";
const Start = ({dataUrl='/Data/Start.json',theme}) => {
  const navigate = useNavigate();
  const { clearUserData } = useUserData();
    useEffect(() => {
      if(theme) {
        document.body.setAttribute('data-theme', theme);
      }else {
        document.body.removeAttribute('data-theme');
      }
    }, [theme]);
    useEffect(()=>{
      ampOnboardingStarted();
      fbPageView();
    },[])
  const { data } = useFetchData(dataUrl);
  if (!data) {
    return <Spinner />;
  }
 
  const { background,logo, Title, Subtitle,button, FooterText } = data;
  return (
    <>
      <Block className={styles.wrapper}>
        {background && <Image src={background} className={styles.background}/>}
        <Container>
          <div className={styles.start}>
            {logo && <Image src={logo} className={styles.icon}/>}
            {Title && <h1 className={styles.title} dangerouslySetInnerHTML={{ __html:Title }} />}
            {Subtitle && <div className={styles.subtitle}>{Subtitle}</div>}
            {button && <button className={styles.button}     onClick={() => {
              clearUserData();
              navigate('/gender');
            }}>{button}</button>}
            {FooterText && <div className={styles.footer} dangerouslySetInnerHTML={{ __html: FooterText }} />}
          </div>
        </Container>
      </Block>
    </>
  )
}
export default Start;